import React, { useRef } from 'react'
import { useGLTF, useTexture } from '@react-three/drei'

export default function Pencil(props) {
  const { nodes, materials } = useGLTF('./models/pencil_02.gltf')
  const colors = props.colors
  const [matCap2] = useTexture([
       'img/matcap2.jpg'
  ])
  
  return (
    <group {...props} dispose={null}>
    <mesh

      geometry={nodes.shadow.geometry}
      position={[0, -0.0005, 0]}
      >
      <meshBasicMaterial color={props.isDark?colors.shadowNight:colors.shadowDay} />
    </mesh>
    <mesh
  
      geometry={nodes.pencil_body.geometry}
      material={materials.Mat}
      position={[0, 0.005, 0]}
      >
      <meshMatcapMaterial matcap={matCap2} color={props.isDark?colors.night:colors.day} />
    </mesh>
    <mesh
      geometry={nodes.pencil_top.geometry}
      material={materials.Mat}
      position={[0, 0.005, 0]}
      >
      <meshMatcapMaterial matcap={matCap2} color={props.isDark?colors.night:colors.day} />
    </mesh>
    <mesh
   
      geometry={nodes['pencil_blacks-Mat1'].geometry}
      material={materials['Mat.1']}
      position={[0, 0.005, 0]}
      >
      <meshMatcapMaterial matcap={matCap2} color={props.isDark?colors.night2:colors.shadowDay} />
    </mesh>
    <mesh

      geometry={nodes['pencil_whites-Mat2'].geometry}
      material={materials['Mat.2']}
      position={[0, 0.005, 0]}
      >
      <meshMatcapMaterial matcap={matCap2} color={props.isDark?colors.white:colors.white} />
    </mesh>
  </group>
  )
}

useGLTF.preload('./models/pencil_02.gltf')
